<template>
    <div style="width: 400px; margin: 0 auto;height:400px; padding-top:30px;" class="registerThird text-center">
        <div class="margin-bottom" >
            <span class="iconfont icon-chenggong text-l-size " style="color: #50D08F!important;"></span>
            <span style="color:#A1A1A1;">恭喜{{userName}}注册成功</span>
        </div>
        <div class="text-l-secondary text-s-size">
            绑定会员激活卡或在线升级你的会员权限，享受超多功能
        </div>
        <div style="padding:30px;">
            <div class="float-left commonFour" >
                <div style="color:#50D08F;">1.名师优课堂</div>
                <div class="text-l-secondary text-s-size">学练结合，精准补弱</div>
            </div>
            <div class="float-right commonFour">
                <div style="color:#79C0FC;">2.生涯规划</div>
                <div class="text-l-secondary text-s-size">提早了解自己的优势，找到适合自己的方向定位</div>
            </div>
        </div>
        <div style="padding: 30px; padding-bottom: 50px;">
            <div class="float-left commonFour">
                <div style="color:#FFB998;">3.心灵成长</div>
                <div class="text-l-secondary text-s-size">迷茫困惑，有我相随</div>
            </div>
            <div class="float-right commonFour">
                <div style="color:#6268EF;">4.新高考选科</div>
                <div class="text-l-secondary text-s-size">帮助学生理清思路，做出适合自己发展的选择</div>
            </div>
        </div>
        <div style="margin: 30px auto;width:350px;">
            <el-button type="primary" style="width: 100%;" @click="$router.push('/login/activation')">绑定学校下发的激活卡</el-button>
        </div>
        <div   style="margin:30px auto;width:350px;">
            <el-button  style="width: 100%;" @click="notActivationInto">稍后激活，即刻体验</el-button>
        </div>
    </div>
</template>

<script>
    import {setSessionStore} from "../../../../assets/static/global/global";

    export default {
        name: "registerThird",
        props:{
            userName:String
        },
        methods:{
            //未激活进入
            notActivationInto(){
                //此值如果有则进入系统后顶部显示’暂未激活？‘，当激活后默认将notActInto置为空
                setSessionStore('notActInto','zhi');
                this.$router.push('/studentAndTeacherPlatform?xiu=la');
            }
        }

    }
</script>

<style lang="scss" scoped>
    .registerThird{
        -webkit-box-shadow: 0px 0px 20px 12px rgb(210 213 222 / 50%);
        box-shadow: 0px 0px 20px 12px rgb(210 213 222 / 50%);
    }
    .commonFour{
        width:170px;
        text-align: left;
    }
</style>